module.exports = function (Component) {
  Component.options.__i18n = Component.options.__i18n || []
  Component.options.__i18n.push('{"en":{"settings.azure.title":"Azure Cloud Connections","settings.azure.subtitle":"All cloud connections importing Azure usage data in this tenant."}}')
  delete Component.options._Ctor
}
